// extracted by mini-css-extract-plugin
module.exports = {"l8u4wkb":"l8u4wkb","slide":"slide","c680jzm":"c680jzm","item":"item","left":"left","right":"right"};